module.exports = __webpack_public_path__ + "static/media/archive.837e4b5d.svg";